/*
 * @Author: linwl 1015547748@qq.com
 * @Date: 2025-10-14 15:46:25
 * @LastEditors: linwl 1015547748@qq.com
 * @LastEditTime: 2025-12-31 11:27:49
 * @FilePath: \mall\src\router\routes\cakeMap.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import CakeLayout from '@/layout/CakeLayout/index.vue'

const cakeMap = [
  {
    path: '/cake',
    name: 'Cake',
    component: CakeLayout,
    redirect: 'cake/cake-home',
    children: [
      {
        path: '/cake/cake-home',
        name: 'CakeHome',
        component: () => import('@/views/cakeHome'),
        meta: {
          name: '蛋糕首页',
          keepAlive: true,
          showHeadBar: false,
          locationMode: 'wait'
        },
        icon: {}
      },
      {
        path: '/cake/cake-brands',
        name: 'CakeBrands',
        component: () => import('@/views/cakeBrands'),
        meta: {
          name: '蛋糕品牌',
          locationMode: 'wait'
        },
        icon: {}
      },
      {
        path: '/cake/cake-detail',
        name: 'CakeDetail',
        component: () => import('@/views/cakeDetail'),
        meta: {
          name: '蛋糕详情',
          locationMode: 'wait'
        }
      },
      {
        path: '/cake/cake-brand-detail',
        name: 'CakeBrandDetail',
        component: () => import('@/views/cakeBrandDetail'),
        meta: {
          name: '品牌详情',
          locationMode: 'wait'
        }
      },
      {
        path: '/cake/cake-deliver-goods',
        name: 'CakeDeliverGoods',
        component: () => import('@/views/cakeDeliverGoods'),
        meta: {
          name: '蛋糕配送',
          locationMode: 'wait'
        }
      },
      {
        path: '/cake/cake-to-store',
        name: 'CakeToStore',
        component: () => import('@/views/cakeToStore'),
        meta: {
          name: '蛋糕到店',
          showHeadBar: false,
          locationMode: 'wait'
        }
      },
      {
        path: '/cake/cake-store-detail',
        name: 'CakeStoreDetail',
        component: () => import('@/views/cakeStoreDetail/'),
        meta: {
          name: '店铺详情',
          locationMode: 'wait'
        }
      },
      {
        path: '/cake/cake-store-list',
        name: 'CakeStoreList',
        component: () => import('@/views/cakeToStoreList/'),
        meta: {
          name: '店铺列表'
        }
      },
      {
        path: '/cake/cake-card-detail',
        name: 'CakeCardDetail',
        component: () => import('@/views/cakeCardDetail'),
        meta: {
          name: '详情'
        }
      },
      {
        path: '/other/jinKo/goodsInfo',
        name: 'JinKoGoodsInfo',
        component: () =>
          import('@/views/other/jinKo/goodsInfo'),
        meta: {
          name: '商品详情'
        }
      }
    ]
  }
]

export default cakeMap
